export default "__VITE_ASSET__BpwtEYq2__"